// ==========================================================================
// FILE: /app/components/onboarding/types.ts
// ==========================================================================
export type FlowKey =
  | "profile"
  | "invite"
  | "auth_matrix"
  | "beneficiary"
  | "third_party"
  | "settings";
 
export interface FlowDef {
  id: FlowKey;
  label: string;
  shortLabel: string;
}
 
export const FLOWS: FlowDef[] = [
  { id: "profile", label: "Setup Your Profile", shortLabel: "Profile" },
  { id: "invite", label: "Invite New User", shortLabel: "Invite User" },
  { id: "auth_matrix", label: "Add Auth Matrix", shortLabel: "Auth Matrix" },
  {
    id: "beneficiary",
    label: "Add New Beneficiary",
    shortLabel: "Beneficiary",
  },
  { id: "third_party", label: "Third-Party Services", shortLabel: "3rd Party" },
  { id: "settings", label: "App Settings", shortLabel: "Settings" },
];
 
/* ---------------------------------------------------------------------- */
/* Profile flow                                                           */
/* ---------------------------------------------------------------------- */

export interface ProfileFormData {
  firstName: string;
  lastName: string;
  email: string;
  mobileNumber: string;
  mobileDialCode: string;
  selectedCountry: string;
  tradeLicense: string;
  companyLandline: string;
  companyPoBox: string;
   addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressLine4: string;
  countryCode2: string;

  // Trade License renewal
  tradeLicenseCurrentEndDate: string;
  tradeLicenseNewEndDate: string;
  tradeLicenseFile: File | null;
  tradeLicenseFileName: string;

  // WhatsApp preference
  whatsappOptIn: boolean;
  whatsappNumber: string;
  whatsappDialCode: string;
}
 
export const initialProfileData: ProfileFormData = {
  firstName: "Aisha",
  lastName: "Al Farsi",
  email: "aisha.alfarsi@company.com",
  mobileNumber: "501234567",
  mobileDialCode: "+971",
  selectedCountry: "United Arab Emirates",
  tradeLicense: "CN-1029384",
  companyLandline: "+971 4 555 0199",
  companyPoBox: "112233",
};
 
/* ---------------------------------------------------------------------- */
/* Invite flow                                                            */
/* ---------------------------------------------------------------------- */
export interface InviteIdProof {
  idType: { id: number; label: string } | null;
  idNumber: string;
}
 
export interface InviteFormData {
  firstName: string;
  lastName: string;
  email: string;
  mobileNumber: string;
  mobileDialCode: string;
  selectedCountry: string;
  idProof: InviteIdProof;
  whatsappEnabled: boolean;
  whatsappNumber: string;
  whatsappDialCode: string;
  selectedRoleValue: string;
  selectedRoleName: string;
  selectedGroup: string;
  supportedCountryIds: number[];
}
 
export const initialInviteData: InviteFormData = {
  firstName: "",
  lastName: "",
  email: "",
  mobileNumber: "",
  mobileDialCode: "+971",
  selectedCountry: "",
  idProof: { idType: null, idNumber: "" },
  whatsappEnabled: false,
  whatsappNumber: "",
  whatsappDialCode: "+971",
  selectedRoleValue: "",
  selectedRoleName: "",
  selectedGroup: "",
  supportedCountryIds: [],
};
 
/* ---------------------------------------------------------------------- */
/* Beneficiary flow                                                       */
/* ---------------------------------------------------------------------- */
export interface BeneficiaryFormData {
  name: string;
  nickName: string;
  email: string;
  mobile: string;
  countryDialCode: string;
  address: string;
  bankCountry: string;
  account: string;
}
 
export const initialBeneficiaryData: BeneficiaryFormData = {
  name: "",
  nickName: "",
  email: "",
  mobile: "",
  countryDialCode: "+971",
  address: "",
  bankCountry: "",
  account: "",
};
 
/* ---------------------------------------------------------------------- */
/* Settings flow                                                          */
/* ---------------------------------------------------------------------- */
export interface SettingsFormData {
  language: string;
  timeZone: string;
  whatsappOptIn: boolean;
  whatsappNumber: string;
  whatsappDialCode: string;
}
 
export const initialSettingsData: SettingsFormData = {
  language: "English",
  timeZone: "Set Automatically",
  whatsappOptIn: false,
  whatsappNumber: "",
  whatsappDialCode: "+971",
};